import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const Conditions: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 60)} fill="none">
            <Path
                d="M51.137 11.888A13.189 13.189 0 0041.791 8a13.189 13.189 0 00-9.346 3.888l-2.556 2.559-2.547-2.559a13.19 13.19 0 00-9.28-3.664 13.193 13.193 0 00-9.19 3.889 13.31 13.31 0 00-3.871 9.23 13.313 13.313 0 003.648 9.322l2.548 2.559L29.889 52l18.693-18.776 2.547-2.56A13.308 13.308 0 0055 21.278c0-3.522-1.392-6.899-3.87-9.389h.007z"
                stroke={props.color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33 22a1 1 0 00-1-1h-4a1 1 0 00-1 1v3a1 1 0 01-1 1h-3a1 1 0 00-1 1v4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 001 1h4a1 1 0 001-1v-3a1 1 0 011-1h3a1 1 0 001-1v-4a1 1 0 00-1-1h-3a1 1 0 01-1-1v-3z"
                fill="#fff"
            />
            <Path
                d="M28 21.5h4v-1h-4v1zm-.5 3.5v-3h-1v3h1zM23 26.5h3v-1h-3v1zm-.5 4.5v-4h-1v4h1zm3.5.5h-3v1h3v-1zm1.5 4.5v-3h-1v3h1zm4.5.5h-4v1h4v-1zm.5-3.5v3h1v-3h-1zm4.5-1.5h-3v1h3v-1zm.5-4.5v4h1v-4h-1zm-3.5-.5h3v-1h-3v1zM32.5 22v3h1v-3h-1zm1.5 3.5a.5.5 0 01-.5-.5h-1a1.5 1.5 0 001.5 1.5v-1zm4.5 1.5a1.5 1.5 0 00-1.5-1.5v1a.5.5 0 01.5.5h1zM37 32.5a1.5 1.5 0 001.5-1.5h-1a.5.5 0 01-.5.5v1zm-3.5.5a.5.5 0 01.5-.5v-1a1.5 1.5 0 00-1.5 1.5h1zM32 37.5a1.5 1.5 0 001.5-1.5h-1a.5.5 0 01-.5.5v1zM26.5 36a1.5 1.5 0 001.5 1.5v-1a.5.5 0 01-.5-.5h-1zm-.5-3.5a.5.5 0 01.5.5h1a1.5 1.5 0 00-1.5-1.5v1zM21.5 31a1.5 1.5 0 001.5 1.5v-1a.5.5 0 01-.5-.5h-1zm1.5-5.5a1.5 1.5 0 00-1.5 1.5h1a.5.5 0 01.5-.5v-1zm3.5-.5a.5.5 0 01-.5.5v1a1.5 1.5 0 001.5-1.5h-1zm5.5-3.5a.5.5 0 01.5.5h1a1.5 1.5 0 00-1.5-1.5v1zm-4-1a1.5 1.5 0 00-1.5 1.5h1a.5.5 0 01.5-.5v-1z"
                fill={props.color}
            />
        </Svg>
    );
};

export default React.memo(Conditions);
